import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../ThemeProvider';
import appIcons from '../../../assets/app-icons';
import classes from './ToolCard.styles.less';
export default function ToolCard({ className, name, description, link }) {
    const [theme] = useTheme();
    return (_jsxs(Link, { className: cx(classes.tool, classes[theme], className), to: link, children: [_jsx("div", { className: classes.header, children: _jsx("img", { className: classes.icon, src: appIcons[link], alt: name, width: "100", height: "100" }) }), _jsxs("div", { className: classes.body, children: [_jsx("h2", { className: classes.name, children: name }), _jsx("p", { className: classes.description, children: description })] })] }));
}
